import React, { useEffect, useState } from "react";
import axios from "axios";
import "./jobDetails.css";
import "../home/home.css";
import Header from "../layout/header";
import Suggestion from "../suggestion/suggesstion";
import RecentChat from "../recentChat/recentChat";
import {
  FormGroup,
  Form,
  Input,
  InputGroupText,
  InputGroup,
  Button,
  CardText,
} from "reactstrap";
import { Card, CardContent } from "@mui/material";
import Oval1 from "../../assets/img/icons/common/Oval1.png";
import userJob from "../../assets/img/icons/common/userJob.png";
import Dropzone from "../helpers/dropzone/Dropzone";
import { Link, useParams, useNavigate } from "react-router-dom";
import fetchApi from "../../common/fetchApi";
import api from "../../routes/api";
import { format } from "timeago.js";
import toast, { Toaster } from "react-hot-toast";
import Avatar from "react-avatar";
import validator from "validator";
import DOMPurify from "dompurify";
import {
  FacebookShareButton,
  LinkedinShareButton,
  TwitterShareButton,
  WhatsappShareButton,
  TelegramShareButton,
  TumblrShareButton,
  VKShareButton,
  PinterestShareButton,
  RedditShareButton,
} from "react-share";
import {
  FacebookIcon,
  FacebookMessengerIcon,
  LinkedinIcon,
  TwitterIcon,
  PinterestIcon,
  WhatsappIcon,
  RedditIcon,
  TumblrIcon,
  VKIcon,
  TelegramIcon,
} from "react-share";
import JobsSchema from "./jobsSchema";
import { Helmet } from "react-helmet";

const JobDetails = (props) => {
  const [state, setState] = useState({
    post: {},
    userId: "",
  });

  const navigate = useNavigate();

  useEffect(() => {
    //console.log("job details");
    const user = JSON.parse(localStorage.getItem("user"));

    if (user && user.data && user.data.success) {
      setState({ ...state, userId: user.data.data.id });
    }
    getPostById();

    const script = document.createElement("script");
    script.src =
      "https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-5121538459968588";

    script.async = true;
    script.crossorigin = "anonymous";
    script.defer = true;
    document.body.appendChild(script);
  }, []);

  const slugify = (str) => {
    if (str?.length) {
      return str
        .toLowerCase()
        .trim()
        .replace(/[^\w\s-]/g, "")
        .replace(/[\s_-]+/g, "-")
        .replace(/^-+|-+$/g, "");
    }
  };

  const { jobId } = useParams();

  const getPostById = async () => {
    const user = JSON.parse(localStorage.getItem("user"));
    let userId;
    let token;
    if (user?.data?.data.id) {
      token = user.data.token;
      userId = user.data.data.id;
    }
    const result = await axios({
      url: api.fetchJobPostById,
      method: "POST",
      headers: {
        Authorization: "Bearer" + token,
      },
      data: {
        id: jobId,
        userId,
      },
    });
    console.log("job details===>", result);

    if (result && result.data && result.data.success) {
      setState({ ...state, post: result.data.result });

      console.log(state.userId, state.post.redirectUrl, "<<<redirect");
    } else {
      navigate("/jobs");
      setState({ ...state, post: {} });
    }
  };

  const unslugify = (str) => str.replace("-", " ").toUpperCase().trim();

  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>{state.post.title}</title>
        <meta name="description" content={state.post.title} />
        <script
          async
          src="https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-5121538459968588"
          crossorigin="anonymous"
        ></script>
      </Helmet>
      <Header />
      <JobsSchema jobs={state.post} />
      {state.post && (
        <div className="row main-containt-box mx-0">
          <div className="chat-main-box">
            <div className="row mt-2">
              <div className="col-md-12 col-sm-12">
                <Card>
                  <CardContent>
                    <div className="row">
                      <div className="col-sm-9 d-flex">
                        <div className="p-1">
                          <Button color="primary" size="lg">
                            <img src={userJob} alt="" />{" "}
                          </Button>
                        </div>
                        <ul className="list-unstyled mb-0 ml-3">
                          <li
                            className="list-unstyled-item text-start text-capitalize poppins blackClr"
                            style={{ fontSize: "14px" }}
                          >
                            <h1>{state.post.title}</h1>
                          </li>
                          <li
                            className="list-unstyled-item text-start my-1 text-capitalize poppins"
                            style={{ fontSize: "14px" }}
                          >
                            <a
                              className="text-primary"
                              href={
                                `https://fonolive.com/search/jobs/company/` +
                                slugify(state.post.comp_name)
                              }
                            >
                              {state.post.comp_name}
                            </a>{" "}
                            in{" "}
                            <a
                              href={
                                `https://fonolive.com/search/jobs/location/` +
                                slugify(
                                  state.post.city +
                                    " " +
                                    state.post.state +
                                    " " +
                                    state.post.country
                                )
                              }
                            >
                              {state.post.city}, {state.post.state},{" "}
                              {state.post.country}
                            </a>
                          </li>
                        </ul>
                      </div>
                      <div className="col-sm-3">
                        <ul className="list-unstyled rspns-apply ml-auto mb-0 text-right">
                          <li
                            className="list-unstyled-item mb-sm-1 mb-0"
                            style={{ fontSize: "14px" }}
                          >
                            <span className="text-capitalize text-end">
                              {state.post.category}
                            </span>
                          </li>
                          <li
                            className="list-unstyled-item text-start poppins poppins text-lowercase text-right"
                            style={{ fontSize: "12px" }}
                          >
                            {format(state.post.createdAt)}{" "}
                          </li>
                        </ul>
                      </div>
                    </div>
                    <CardText className="mt-4 mb-0">
                      <span>
                        <a href="https://play.google.com/store/apps/details?id=com.fonolive">
                          <img
                            src="/google-play-badge.png"
                            height={56}
                            width={120}
                            alt="Fonolive Marketplace App on Google Playstore"
                          />
                        </a>
                      </span>
                      <span>
                        <a href="https://apps.apple.com/us/app/fonolive-social-marketplace/id6450934952">
                          <img
                            src="https://fonolive.com/apple-store-badge.png"
                            height={40}
                            width={110}
                            alt="Fonolive Marketplace App on App Store - Apple iOS"
                          />
                        </a>
                      </span>
                      <h6 className="poppins text-start fs-6 text-capitalize">
                        jobs description
                      </h6>
                      <p
                        className="poppins text-justify"
                        dangerouslySetInnerHTML={{
                          __html: DOMPurify.sanitize(
                            state.post.desc
                              ? state.post.desc?.replace("Job Bank", "")
                              : state.post.desc
                          ),
                        }}
                      ></p>
                      <h6 className="poppins text-start text-dark text-capitalize mt-2">
                        salary-criteria
                      </h6>
                      <p className="poppins text-justify">
                        {state.post.salary_criteria}
                      </p>
                      {state.post.email && (
                        <a href={"mailto:" + state.post.email}>
                          Please submit application to -:{" "}
                          <h5>{state.post.email}</h5>
                        </a>
                      )}
                      {state.post.redirectUrl && !state.post.email && (
                        <a
                          href={state.post.redirectUrl}
                          target="_blank"
                          rel="nofollow"
                        >
                          Apply Now (external) - <h2>{state.post.title}</h2>
                        </a>
                      )}
                      {state.post && <div></div>}
                      <div style={{ marginTop: "10px" }}>
                        <TwitterShareButton
                          url={`${window.location.origin}/job-details/${state.post.id}`}
                        >
                          <TwitterIcon size={32} round={true} />
                        </TwitterShareButton>
                        <FacebookShareButton
                          url={`${window.location.origin}/job-details/${state.post.id}`}
                        >
                          <FacebookIcon size={32} round={true} />
                        </FacebookShareButton>
                        <RedditShareButton
                          url={`${window.location.origin}/job-details/${state.post.id}`}
                        >
                          <RedditIcon size={32} round={true} />
                        </RedditShareButton>
                        <WhatsappShareButton
                          url={`${window.location.origin}/job-details/${state.post.id}`}
                        >
                          <WhatsappIcon size={32} round={true} />
                        </WhatsappShareButton>
                        <LinkedinShareButton
                          url={`${window.location.origin}/job-details/${state.post.id}`}
                        >
                          <LinkedinIcon size={32} round={true} />
                        </LinkedinShareButton>
                        <TelegramShareButton
                          url={`${window.location.origin}/job-details/${state.post.id}`}
                        >
                          <TelegramIcon size={32} round={true} />
                        </TelegramShareButton>
                        <VKShareButton
                          url={`${window.location.origin}/job-details/${state.post.id}`}
                        >
                          <VKIcon size={32} round={true} />
                        </VKShareButton>
                      </div>
                    </CardText>
                  </CardContent>
                  {props.public && (
                    <div className="d-flex align-items-center justify-content-center mb-2">
                      <p className="text-dark m-0 mr-4">Want to Apply?</p>
                      <button
                        className="btn btn-primary"
                        onClick={() => navigate("/login")}
                      >
                        Log In
                      </button>
                    </div>
                  )}
                </Card>
                {!props.public && (
                  <Card>
                    <CardContent>
                      <div className="row">
                        <div className="col-lg-12">
                          <ul className="list-group w-100">
                            {state.post.userId !== state.userId ? (
                              ""
                            ) : (Array.isArray(state.post.applicants) &&
                                state.post.applicants.length) == 0 ? (
                              <div className="text-dark fs-6">
                                No applicants list
                              </div>
                            ) : (
                              state.post.applicants.map((item) => {
                                return (
                                  <li className="d-flex align-items-center mb-3 border-bottom pb-3">
                                    <div className="chat-img mr-3">
                                      {
                                        <Avatar
                                          name={item.firstname}
                                          size="48"
                                          round={true}
                                        />
                                      }
                                    </div>
                                    <div className="fs-6 poppins">
                                      {item.firstname + " " + item.lastname}
                                    </div>
                                    <div className="ml-auto">
                                      <a
                                        href={item.location}
                                        target="__blank"
                                        className="btn btn-primary btn-sm br-25 ml-auto"
                                      >
                                        View / Download
                                      </a>
                                    </div>
                                  </li>
                                );
                              })
                            )}
                          </ul>
                        </div>
                      </div>
                    </CardContent>
                  </Card>
                )}
                {!props.public && (
                  <Card>
                    <CardContent>
                      <div className="row">
                        <div className="col-lg-12">
                          {console.log(state.post.userId, state.userId)}
                          {state.post.userId === state.userId ? (
                            ""
                          ) : (
                            <div
                              className="content"
                              onClick={() => {
                                if (!state.userId) {
                                  navigate("/login");
                                }
                              }}
                            >
                              <Dropzone jobId={jobId} />
                            </div>
                          )}
                        </div>
                      </div>
                    </CardContent>
                  </Card>
                )}
              </div>
            </div>
            <div>
              <a
                style={{ fontSize: "10px" }}
                href={`https://fonolive.com/jobs/query/${slugify(
                  state.post.title
                )}`}
              >
                More : {state.post.title}
              </a>
            </div>
            {!props.public && (
              <div className="row mt-3">
                {state.post.userId === state.userId ? (
                  ""
                ) : (
                  <div className="col-md-12 col-sm-12">
                    <Card className="myResumebg">
                      <CardContent className="justify-content-center">
                        <div className="row mt-2 justify-content-center">
                          <div className="col-md-3 col-sm-12 border-primary">
                            <Card className="rounded">
                              <CardContent className="text-center">
                                <Link to="/resume">
                                  <button className="btn btn-primary circle-rounded btn-sm">
                                    <i className="fa fa-plus"></i>
                                  </button>
                                </Link>
                                <p className="mt-2 mb-0">
                                  <Link
                                    to="/resume"
                                    className="text-capitalize font-weight-bold fs-6"
                                  >
                                    create a resume
                                  </Link>
                                </p>
                              </CardContent>
                            </Card>
                          </div>
                        </div>
                      </CardContent>
                    </Card>
                  </div>
                )}
              </div>
            )}
          </div>
        </div>
      )}
      <Toaster />
    </>
  );
};
export default JobDetails;
